/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FormArray } from '@angular/forms';

export class PartialySavedFittings {
  NominalSizeList;
  PartialySavedFittings: FormArray;
}

